import { createContext, useContext } from 'react';
import { noop } from 'es-toolkit/compat';
import { isMobile, isMobileScreen } from '@rio-cloud/rio-uikit/DeviceUtils';
import type { ListMenuItem } from '@rio-cloud/rio-uikit/components/listMenu/ListMenuGroup';

import { STYLE_RIO_LIGHT } from './header/Themes';

type UikitContextType = {
    theme: string;
    showMenu: boolean;
    onMenuIconClicked: () => void;
    onMenuOutsideClicked: (event: MouseEvent | TouchEvent) => void;
    startMenu: ListMenuItem[];
    foundationsMenu: ListMenuItem[];
    componentsMenu: ListMenuItem[];
    uiTemplateMenu: ListMenuItem[];
    utilitiesMenu: ListMenuItem[];
    internalMenu: ListMenuItem[];
};

export const UikitContext = createContext<UikitContextType>({
    theme: STYLE_RIO_LIGHT,
    showMenu: !(isMobile() || isMobileScreen()),
    onMenuIconClicked: noop,
    onMenuOutsideClicked: noop,
    startMenu: [],
    foundationsMenu: [],
    componentsMenu: [],
    uiTemplateMenu: [],
    utilitiesMenu: [],
    internalMenu: [],
});

export const useUikitContext = () => useContext(UikitContext);
